import produce from 'immer';
import { handleActions } from 'redux-actions';

const initialState = {};

export default handleActions(
  {
    'ROBOT_PARAMS/RESET': (state, action) => initialState,
    'ROBOT_PARAMS/INIT': (state, action) =>
      produce(state, (draft) => {
        const { robotId } = action.payload;

        draft[robotId] = {
          params: {},
          lastParamId: null,
          count: null,
        };
      }),
    'ROBOT_PARAMS/SET': (state, action) =>
      produce(state, (draft) => {
        const { robotId, data } = action.payload;
        const { paramId, paramValue, paramType, paramCount, paramIndex } = data;

        draft[robotId].lastParamId = paramId;

        const existingParam = state[robotId].params[paramId];
        // 기존 파라미터 값과 동일한 경우
        if (existingParam?.value === paramValue) return;

        // 총 파라미터 개수 정의되지 않은 경우
        if (state[robotId].count === null) {
          draft[robotId].count = paramCount;
        }

        draft[robotId].params[paramId] = {
          id: paramId,
          value: paramValue,
          type: paramType,
          index: paramIndex,
        };
      }),
    'ROBOT_PARAMS/REMOVE': (state, action) =>
      produce(state, (draft) => {
        const { robotId } = action.payload;

        delete draft[robotId];
      }),
  },
  initialState,
);
